export function populateCollectPointsBox(entry, container, timelineElement) {
    if (container[0]?.classList.contains("already-loaded")) {
        return;
    } else {
        container?.[0]?.classList.add("already-loaded");
    }
    container.addClass("collection_points");
    var clonedBox = $(".collection_points_box_prototype").clone().appendTo(container);
    clonedBox.removeClass("collection_points_box_prototype");
    clonedBox.removeClass("hidden");
    clonedBox.addClass("collection_points_box");
    clonedBox.find(".headline").prepend(entry.description);
    clonedBox.find(".expiry_date").text(dbDateToString(entry.code_expiry_date, false));
    clonedBox.find(".codename").text(entry.fk_code);
    clonedBox.find(".spinner").hide();
    clonedBox.find(".author_comment").html(entry.content);
    var expiryDate = stringToDate(entry.code_expiry_date);
    var currentDate = new Date();

    var timeContainer = clonedBox.find(".time_container_timeline");
    var daysContainer = timeContainer.find(".days").find(".box").text("0");
    var hoursContainer = timeContainer.find(".hours").find(".box").text("0");
    var minutesContainer = timeContainer.find(".minutes").find(".box").text("0");
    var secondsContainer = timeContainer.find(".seconds").find(".box").text("0");

    if (expiryDate <= currentDate) {
        clonedBox.find(".redeem_code").addClass("inactive").text("Code abgelaufen");
    } else {
        setInterval(function () {
            refreshTime(daysContainer, hoursContainer, minutesContainer, secondsContainer, expiryDate);
        }, 200);
    }
    if (timelineElement !== undefined) {
        addImpression(timelineElement.id);
    }
}